<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_111_31215)">
      <path d="M4.54987 35.0003H35.4332C36.7165 35.0003 37.5165 33.6169 36.8832 32.5003L21.4332 5.83359C20.7832 4.71693 19.1832 4.71693 18.5499 5.83359L3.09987 32.5003C2.46654 33.6169 3.26654 35.0003 4.54987 35.0003ZM21.6665 30.0003H18.3332V26.6669H21.6665V30.0003ZM19.9999 23.3336C19.0832 23.3336 18.3332 22.5836 18.3332 21.6669V18.3336C18.3332 17.4169 19.0832 16.6669 19.9999 16.6669C20.9165 16.6669 21.6665 17.4169 21.6665 18.3336V21.6669C21.6665 22.5836 20.9165 23.3336 19.9999 23.3336Z" fill="#D11635"/>
    </g>
    <defs>
      <clipPath id="clip0_111_31215">
        <rect width="40" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
